export default __webpack_public_path__ + "static/media/arrow-left.d3543b47.svg";